/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_FreeInputs */



/**
* | output |
* | --- |
* | "Free" |
*
* @param {Tournament_Wiz_Doors_FreeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_free = /** @type {((inputs?: Tournament_Wiz_Doors_FreeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_FreeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gratuit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gratuito")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Grátis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gratuito")
	return /** @type {LocalizedString} */ ("Free")
});